export const initialInput = {
  mailValue: "",
  mailIsTouched: false,
  phoneValue: "",
  phoneIsTouched: false,
  passwordValue: "",
  passwordIsTouched: false,
};

export const inputReducer = (state, action) => {
  switch (action.type) {
    case "MAIL_INPUT":
      return {
        ...state,
        mailValue: action.mailValue,
        mailIsTouched: state.mailIsTouched,
      };
    case "MAIL_BLUR":
      return { ...state, mailIsTouched: true, mailValue: state.mailValue };
    case "PHONE_INPUT":
      console.log(action)
      return {
        ...state,
        phoneValue: action.phoneValue,
        phoneIsTouched: state.phoneIsTouched,
      };
    case "PHONE_BLUR":
      return { ...state, phoneIsTouched: true, phoneValue: state.phoneValue };
    case "PASSWORD_INPUT":
      return {
        ...state,
        passwordValue: action.passwordValue,
        passwordIsTouched: state.passwordIsTouched,
      };
    case "PASSWORD_BLUR":
      return {
        ...state,
        passwordIsTouched: true,
        passwordValue: state.passwordValue,
      };

    case "RESET_PASSWORD":
      return {
        ...state,
        passwordValue: "",
        passwordIsTouched: false,
      };
    case "RESET":
      return {
        mailValue: "",
        mailIsTouched: false,
        phoneValue: "",
        phoneIsTouched: false,
        passwordValue: "",
        passwordIsTouched: false,
      };
    default:
      return state;
  }

  console.log(state)
};

export default inputReducer;
